import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFinAtmData } from "../../../../store/Api";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import FileUploadElement from "../../../../ReusableComponents/UploadFile/uplaodFile";
import FinListAtmPayRoll from './FinListAtmPayRoll';


export default function FinAtmPayRoll() {
    const data = useSelector((state) => state.getFinAtm);
    //screen Title Show fun
    const titleBorder = [{ label: 'ATM/PayRoll', link: '/dashboard/AtmPayroll' }];
    useEffect(() => {
        dispatch(setBreadCrumb(titleBorder));
        dispatch(getFinAtmData(token));
    }, []);


    const updateData = () => {
        dispatch(getFinAtmData(token));
    };


    const dispatch = useDispatch();

    const [loading, setLoading] = useState({
        updateData: false,
        uploadFile: false,
        listData: false,
        loadingId: "",
    });
    const token = localStorage.getItem("nodeToken");

    const [showPromptElement, setShowPromptElement] = useState({
        open: false,
    });
    return (
        <div className={`ml-5 mr-5`}>
            {showPromptElement.open && (
                <FileUploadElement
                    title={"Upload Tamplate with Border Number"}
                    subTitle={"Upload templete"}
                    showFileUploadElement={showPromptElement}
                    setShowFileUploadElement={setShowPromptElement}
                    uploadFile={uploadFile}
                />
            )}
            <FinListAtmPayRoll
                list={data}
                loading={loading}
                titles={[
                    "S.NO.",
                    "EMPLOYEE ID",
                    "EMPLOYEE NAME",
                    "CLIENT",
                    "VISA PROVIDER",
                    "IQAMA NUMBER",
                    "IQAMA EXPIRY DATE (G)",
                    "IQAMA EXPIRY DATE (H)",
                    "KSA CONTACT NUMBER",
                    "ACCOUNT TO BE OPENED BY",
                    "FEES",
                    "PAYMENT STATUS",
                    "ACTION"
                ]}
                token={token}
                updateData={updateData}
                uploadFile={setShowPromptElement}
            />
        </div>
    );
}
